import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal.jsx';
import { TRUST, CONTACT } from '../content/site.js';

export default function Trust() {
  return (
    <>
      <section className="page-head">
        <div className="shell">
          <p className="eyebrow">Trust Center</p>
          <h1>Security you can verify</h1>
          <p className="lede" style={{ marginTop: '1.2rem' }}>{TRUST.lede}</p>
        </div>
      </section>

      <section className="section" style={{ paddingTop: '2rem' }}>
        <div className="shell">
          <div className="grid grid-4 stat-band">
            {TRUST.targets.map(([value, label]) => (
              <div key={label}>
                <p className="stat-value">{value}</p>
                <p className="eyebrow eyebrow-grey" style={{ margin: 0 }}>{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="grid grid-2">
            {TRUST.controls.map(([title, body], i) => (
              <Reveal key={title} delay={i * 60}>
                <div className="card">
                  <h3>{title}</h3>
                  <p className="dim" style={{ marginTop: '0.6rem' }}>{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <Reveal className="railed">
            <p className="eyebrow">Responsible disclosure</p>
            <h2>Found something? Tell us.</h2>
            {TRUST.disclosure.map((p) => (
              <p key={p.slice(0, 24)} className="dim" style={{ marginTop: '1rem', maxWidth: '44rem' }}>{p}</p>
            ))}
            <p style={{ marginTop: '1.6rem' }}>
              <a className="btn btn-primary" href={`mailto:${CONTACT.security}`}>{CONTACT.security}</a>
            </p>
            <p className="faint" style={{ marginTop: '1rem', fontSize: '0.85rem' }}>
              Machine-readable at <a href="/.well-known/security.txt">/.well-known/security.txt</a>.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <Reveal className="cta">
            <h2>Questions about our security?</h2>
            <p className="lede" style={{ marginTop: '1rem' }}>
              We are happy to walk through our controls, documentation, or vendor onboarding
              requirements.
            </p>
            <p style={{ marginTop: '1.8rem' }}>
              <Link to="/contact" className="btn btn-primary">Contact our team</Link>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
